import React from "react";
import "./style/utils.style.css";

const Tooltip = (props) => {
  return (
    <div className="tooltip">
      {props.children}
      <span className="tooltiptext">{props.content}</span>
    </div>
  );
};
export default Tooltip;
